@if (enclosure?.enclosureDescription; as description) {
  <div class="font-size-11 font-weight-normal wrap-on-small-screens" >
    <app-ui-product-range-name [name]="description?.name"></app-ui-product-range-name> |
    @switch (description?.mountingType) {
      @case (enclosureTypes.WallMounted) {
        <ng-container i18n="@@app.WallMounting">WallMounting</ng-container>
      }
      @case (enclosureTypes.FloorStanding) {
        <ng-container i18n="@@app.FloorStanding">FloorStanding</ng-container>
      }
      @default {
        {{description?.mountingType}}
      }
    }
    | {{description?.ipType}} {{description?.doorType ? '|' : ''}} {{description?.doorType}} | {{description?.rows ? 'F'+ description?.fields + ' R' + description?.rows : ''}}
  </div>
}

